// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__eUp1S","inner":"Footer_inner__hxaXy","nextIcon":"Footer_nextIcon__3hJth","innerLeft":"Footer_innerLeft__FCaPu"};